// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {toLower} from 'lodash';

// Redux Actions
import {authenticate, clearError} from '../../actions/auth-actions';
import {preferencesInit} from '../../actions/preferences-actions';

// Components
import Button from './button';
import Error from './error';
import ForgotPassword from '../app/forgot-password';
import Loading from './loading';

// Containers
import withAuth from '../../containers/with-auth';

// Styles
import './login.scss';

class Login extends Component {
    passwordInput = React.createRef();

    usernameInput = React.createRef();

    state = {
        forgotPassword: false,
    };

    componentWillMount() {
        const {clearError, preferencesInit} = this.props;

        preferencesInit();
        clearError();
    }

    componentDidMount() {
        this.focusOnUsernameInput();
    }

    componentDidUpdate() {
        this.focusOnUsernameInput();
    }

    handleForgotPassword = (event) => {
        event && event.preventDefault && event.preventDefault();

        this.setState({forgotPassword: true});
    };

    handleReset = (event) => {
        event && event.preventDefault && event.preventDefault();

        this.setState({forgotPassword: false});
    };

    handleSubmit = (event) => {
        const {authenticate} = this.props;

        event && event.preventDefault && event.preventDefault();

        authenticate({
            username: toLower(this.usernameInput.current.value),
            password: this.passwordInput.current.value,
        });
    };

    focusOnUsernameInput() {
        if (this.usernameInput.current && this.usernameInput.current.focus) {
            this.usernameInput.current.focus();
        }
    }

    renderForm() {
        const {error, fetching, password = '', user = ''} = this.props;

        const {forgotPassword} = this.state;

        return forgotPassword ? (
            <ForgotPassword onReset={this.handleReset} />
        ) : (
            <div className="login">
                <form className="login--form" name="login">
                    <label className="login--label" htmlFor="login_username">
                        Username
                    </label>
                    <input
                        className="login--input"
                        defaultValue={user}
                        id="login_username"
                        ref={this.usernameInput}
                        type="text"
                    />
                    <label className="login--label" htmlFor="login_password">
                        Password
                    </label>
                    <input
                        className="login--input"
                        defaultValue={password}
                        id="login_password"
                        ref={this.passwordInput}
                        type="password"
                    />
                    <Button onClick={this.handleSubmit}>Log In</Button>
                    <Button className="login--forgot-password-button" onClick={this.handleForgotPassword}>
                        Forgot Password
                    </Button>
                    <Error error={error} />
                    <Loading loading={fetching} />
                </form>
            </div>
        );
    }

    render() {
        const {children, isLoggedIn} = this.props;

        return isLoggedIn() ? children : this.renderForm();
    }
}

Login.propTypes = {
    authenticate: PropTypes.func.isRequired,
    children: PropTypes.node,
    clearError: PropTypes.func.isRequired,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fetching: PropTypes.bool,
    isLoggedIn: PropTypes.func.isRequired,
    password: PropTypes.string,
    preferencesInit: PropTypes.func.isRequired,
    user: PropTypes.string,
};

const mapDispatchToProps = {authenticate, clearError, preferencesInit};

export default withAuth(connect(null, mapDispatchToProps)(Login));
